<mat-divider></mat-divider>
<footer [style.font-family]="displaySetting.Font">{{ text }}</footer>
